import { IMAGE_CREATE_KEY } from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import { getConfluenceEditorClientId } from '@atlassian/rovo-content-bridge-api-commands/clients/confluence-smart-create-editor-client';
import type { AgentType } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';
import { ConfluenceUpdatePageCommand } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import { type SendCommand } from '../context/useBridgeSendCommand';
import { getCurrentPageId } from '../message-stream-action/getCurrentPageId';

const UNKNOWN_AGENT_TYPE: AgentType = 'unknown';

/**
 * Sends a bridge command to clear the AI generating state (decoration)
 * from the existing image node in the editor.
 *
 * This is used in error, abort, and stop-thinking flows to ensure the
 * AI border overlay is removed when the image-create action fails or is cancelled.
 */
export function clearAIGeneratingState(
	sendCommand: SendCommand,
	{
		contentId,
		groupId,
		traceId,
	}: {
		contentId?: string;
		groupId: string;
		traceId?: string;
	},
): void {
	const resolvedContentId = contentId || getCurrentPageId();
	if (!resolvedContentId) {
		return;
	}

	sendCommand(ConfluenceUpdatePageCommand, {
		agentType: UNKNOWN_AGENT_TYPE,
		key: IMAGE_CREATE_KEY,
		agentId: undefined,
		data: { __isError: true },
		isStreamComplete: false,
		receiverId: getConfluenceEditorClientId(resolvedContentId),
		groupId,
		buffer: false,
		traceId,
	});
}
